"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _ButtonConstants = require("../button/ButtonConstants");

var CARET_CLASS_FOR_USE = {
  enclosed: 'private-dropdown__caret--enclosed',
  // special for UIDropdownTab
  form: 'private-dropdown__caret--form',
  'form-on-dark': 'private-dropdown__caret--form',
  'link-on-dark': 'private-dropdown__caret--link-on-dark'
};

var UIDropdownCaret = function UIDropdownCaret(_ref) {
  var className = _ref.className,
      hidden = _ref.hidden,
      use = _ref.use;
  var computedClassName = (0, _classnames.default)("uiDropdown__buttonCaret private-dropdown__caret", className, CARET_CLASS_FOR_USE[use], hidden && 'private-dropdown__caret--hidden');
  return _react.default.createElement("span", {
    className: computedClassName
  });
};

UIDropdownCaret.propTypes = {
  hidden: _propTypes.default.bool,
  use: _propTypes.default.oneOf([].concat((0, _toConsumableArray2.default)(Object.keys(_ButtonConstants.USE_CLASSES)), ['enclosed']))
};
UIDropdownCaret.displayName = 'UIDropdownCaret';
var _default = UIDropdownCaret;
exports.default = _default;
module.exports = exports.default;